module.exports = __webpack_public_path__ + "img/4.2c5a15f3.jpg";